import { Form, Segmented } from 'antd';
import { ChatIcon } from 'assets';
import OmniChannelSourceSelect from 'components/omni-channel-chat-histories/OmniChannelSourceSelect';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { aiAgentCenterMessages, omniChatMessages } from 'messages';
import React, { memo } from 'react';

const AIAgentCenterSessionsFilter: React.FC = () => {
  const { type, setType } = useAIAgentCenterContext();

  return (
    <div className='flex flex-col gap-3 px-5 py-3'>
      <Segmented
        prefixCls='main-segmented'
        className='w-full'
        options={[
          {
            value: 'phone',
            label: aiAgentCenterMessages.calls
          },
          {
            value: 'chat',
            label: aiAgentCenterMessages.chat
          }
        ]}
        value={type}
        onChange={(value) => setType(value as 'phone' | 'chat')}
      />
      {type === 'chat' ? (
        <div className='w-full'>
          <Form.Item name={'chatSource'} noStyle>
            <OmniChannelSourceSelect
              prefix={<ChatIcon height={14} width={14} />}
              className='w-full'
              isAll
              placeholder={aiAgentCenterMessages.channelChat}
            />
          </Form.Item>
        </div>
      ) : null}
    </div>
  );
};
export default memo(AIAgentCenterSessionsFilter);
